export default __webpack_public_path__ + "static/media/banner-5.5373a487.jpg";